import { Honeybadger } from "@honeybadger-io/react"

type UnexpectedErrorContext = Readonly<
  Record<string, string | number | boolean | null>
>

export function reportUnexpectedError(
  error: unknown,
  source: string,
  context: UnexpectedErrorContext = {}
) {
  let reportedError: Error
  try {
    reportedError = error instanceof Error ? error : new Error(String(error))
  } catch {
    reportedError = new Error("Unable to convert thrown value to an Error")
  }

  Honeybadger.notify(reportedError, {
    context: {
      ...context,
      source,
    },
  })
}
